import { gql } from 'apollo-boost';

export const getClients = gql`
    query{
        clients{
            _id,
            name,
            document,
            email,
            phone,
            celphone,
        }
    }
`;

export const getClientsByUser = gql`
    query GetClientsByUser(
        $user: ID!,
    ){
        clientsByUser(
            user: $user
        ){
            _id,
            name,
            document,
            email,
            phone,
            celphone
        }
    }
`;

export const getClient = gql`
    query GetClient(
        $_id: ID!,
    ){
        client(
            _id: $_id
        ){
            _id,
            name,
            document,
            email,
            phone,
            celphone,
            branch_info{
                _id
            }
        }
    }
`;


// WEBPACK FOOTER //
// ./src/graphql/query/client.js